import { render, staticRenderFns } from "./ModalWorkpachages.vue?vue&type=template&id=7af80512"
import script from "./ModalWorkpachages.vue?vue&type=script&lang=js"
export * from "./ModalWorkpachages.vue?vue&type=script&lang=js"
import style0 from "./ModalWorkpachages.vue?vue&type=style&index=0&id=7af80512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports